import * as turf from '@turf/turf';
import mapboxgl from 'mapbox-gl';


const sources_ids = ['sourceCommoditiesBike'];
const layers_ids = ['layerCommoditiesBike_Points'];
var markers = [];
var marker_img = '<svg width="25" height="14" viewBox="0 0 860 475" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1112_30)"><path d="M693.254 450.763L756.166 160.526C760.154 142.128 776.432 129 795.258 129H800C811.046 129 820 137.954 820 149V395C820 406.046 828.954 415 840 415C851.046 415 860 423.954 860 435V455C860 466.046 851.046 475 840 475H712.8C700.047 475 690.552 463.226 693.254 450.763Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M629.073 170.957C635.122 170.222 641.265 169.802 647.509 169.802C676.368 169.802 703.38 177.859 726.414 191.844L714.988 244.523C696.9 228.808 673.296 219.284 647.509 219.284C646.072 219.284 644.644 219.334 643.222 219.393L671.255 315.355C675.087 328.468 667.561 342.206 654.444 346.038C641.341 349.873 627.596 342.344 623.761 329.227L595.735 233.295C565.124 251.169 544.499 284.356 544.499 322.29C544.499 379.091 590.708 425.301 647.509 425.301C657.641 425.301 667.436 423.83 676.692 421.092L670.257 450.761C668.441 459.136 672.133 467.201 678.621 471.591C668.574 473.682 658.167 474.781 647.509 474.781C563.425 474.781 495.018 406.372 495.018 322.29C495.018 261.813 530.411 209.448 581.572 184.811L558.309 105.183L405.216 348.861C400.674 356.092 392.745 360.442 384.271 360.442C383.796 360.442 383.319 360.427 382.839 360.4L301.251 355.679C285.979 423.749 225.101 474.781 152.488 474.781C68.4065 474.781 0 406.374 0 322.29C0 238.206 68.4065 169.802 152.488 169.799C168.5 169.799 183.938 172.295 198.448 176.892L225.87 122.79L215.934 106.44C214.683 104.381 213.785 102.211 213.191 99.9972H208.74C195.076 99.9972 184 88.9186 184 75.2571C184 61.5956 195.076 50.5169 208.74 50.5169H268.339C282.003 50.5169 293.079 61.5956 293.079 75.2571C293.079 82.9216 289.591 89.7746 284.116 94.3119L505.05 91.1081C506.243 91.0759 507.433 91.16 508.593 91.3085L534.872 49.4803H470.238C456.577 49.4803 445.498 38.4017 445.498 24.7402C445.498 11.0786 456.577 0 470.238 0H572.289C585.951 0 597.029 11.0786 597.029 24.7402C597.029 30.8881 594.773 36.5016 591.06 40.8287L629.073 170.957ZM338.569 308.275L256.113 172.568L242.543 199.336C276.308 224.136 299.539 262.468 304.131 306.283L338.569 308.275ZM152.488 219.282C95.69 219.282 49.4803 265.491 49.4803 322.29C49.4803 379.091 95.69 425.301 152.488 425.301C198.681 425.301 237.869 394.736 250.892 352.767L151.058 346.991C142.728 346.508 135.202 341.859 131.041 334.625C126.88 327.391 126.647 318.549 130.42 311.107L175.618 221.934C168.179 220.217 160.442 219.282 152.488 219.282ZM219.727 244.351L191.637 299.771L253.725 303.364C249.358 279.96 237.06 259.326 219.727 244.351ZM296.419 143.619L384.576 288.705L477.374 140.994L296.419 143.619Z" fill="white"/></g><defs><clipPath id="clip0_1112_30"><rect width="860" height="475" fill="white"/></clipPath></defs></svg>';

export const get_ids = () => {
    // Get all source ids
    var sources = [];
    sources_ids.forEach(source_id => {
        sources.push({ id: source_id });
    })
    // Get all layer ids
    var layers = [];
    layers_ids.forEach(layer_id => {
        layers.push({ id: layer_id });
    })

    return {
        sources: sources,
        layers: layers,
        markers: markers,
    }
}


export const get_data = (capacity) => {
    // Set map data
    var map_data = {
        sources: [],
        layers: [],
        markers: [],
        bbox: null
    }

    // Check needed data
    if (!capacity?.context?.commodities?.transports_bike?.items || !capacity.context.commodities.transports_bike.items.length > 0) {
        return map_data
    }

    // Preset layer data
    var layer_data = {
        type: 'FeatureCollection',
        features: [],
    };

    // Add data
    for (var i = 0; i < capacity.context.commodities.transports_bike.items.length; i++) {
        var item = capacity.context.commodities.transports_bike.items[i];
        var item_marker_coords = null;
        // Generate polygon
        if (item?.type === "way" && item?.coords && item.coords.length > 3 && item.coords[0].length === 2 && item.coords[0][0] === item.coords[item.coords.length - 1][0] && item.coords[0][1] === item.coords[item.coords.length - 1][1]) {
            layer_data.features.push({
                type: "Feature",
                properties: item?.properties || null,
                geometry: {
                    type: "Polygon",
                    coordinates: [item.coords],
                }
            });
            try {
                var center = turf.centroid(turf.polygon([item.coords]));
                item_marker_coords = center?.geometry?.coordinates || null;
            } catch (error) {
                item_marker_coords = null;
            }
        }
        // Generate point
        else if (item?.type === "node" && item?.coords && item.coords.length === 2) {
            layer_data.features.push({
                type: "Feature",
                properties: item?.properties || null,
                geometry: {
                    type: "Point",
                    coordinates: item.coords,
                }
            });
            item_marker_coords = item.coords;
        }
        // Generate marker
        if (item_marker_coords !== null && item_marker_coords.length === 2) {
            var title = "Station de vélo";
            var title_txt = '<span style="color:#062134;font-size:15px;font-weight:700"><strong>' + title + '</strong></span>';
            var infos = [
                { label: "Nom", value: item?.properties?.name || "NC" },
                { label: "Nombre d'emplacements", value: item?.properties?.slots || "NC" },
                { label: "Service", value: (item?.properties?.network || "NC") + (item?.properties?.operator ? " (" + item?.properties?.operator + ")" : "")},
                { label: "Distance", value: item?.properties?.distance ? item?.properties?.distance + " m" : "NC" },
            ]
            var infos_txt = infos.map(info => { return ('<br /><span style="font-size:12px;font-weight: 600;color: grey;">' + info.label + ' :</span><br /><span style="color:#062134;font-weight:500;">' + info.value + '</span>') }).join('');
            var marker_label = item?.properties?.name || "";
            var el = document.createElement('div');
            el.className = 'marker';
            el.innerHTML = '<div style="cursor:pointer;padding:3px 8px 2px;background-color:#062134;border-radius:6px;display:flex;justify-content:center;align-items:center;gap:4px"><div style="display:flex;justify-content:center">' + marker_img + '</div><div style="font-family:Manrope;color:#FFF;">' + marker_label + '</div></div>';
            map_data.markers.push(new mapboxgl.Marker(el)
                .setLngLat(item_marker_coords)
                .setPopup(new mapboxgl.Popup({ offset: 15 })
                    .setHTML('<p style="font-family:Manrope">' + title_txt + infos_txt + '</p>'))
            )
        }
    }

    // Check data exists
    if (!layer_data.features.length > 0) {
        return map_data
    }

    // Create sources
    map_data.sources.push(
        {
            id: sources_ids[0],
            value: {
                type: 'geojson',
                data: layer_data
            }
        }
    )

    // Create layers
    map_data.layers.push(
        {
            id: layers_ids[0],
            type: 'fill',
            source: sources_ids[0],
            paint: {
                'fill-color': '#062134',
                'fill-opacity': 0.5,
            },
            filter: ['in', '$type', 'Polygon']
        }
    );

    // Set global markers
    if (map_data.markers.length > 0) {
        markers = map_data.markers;
    }
    else {
        markers = [];
    }

    // Get bbox
    var bbox_data = {
        type: 'FeatureCollection',
        features: layer_data.features.concat([capacity?.landBase?.union?.geometry]),
    };
    var bbox = turf.bbox(bbox_data);
    if (bbox && bbox.length === 4) {
        var bbox_poly = [
            [bbox[0], bbox[1]],
            [bbox[2], bbox[1]],
            [bbox[2], bbox[3]],
            [bbox[0], bbox[3]],
            [bbox[0], bbox[1]],
        ]
        map_data.bbox = [bbox_poly];
    }



    // Return
    // console.log("map_data", map_data);
    return map_data

}

